export function bindInputListeners($form) {
    $form.find('input, select, textarea').on('input change', function () {
        const $row = $(this).closest('.form-row');
        $row.find('.field-error').hide();
    });
}

export function showValidationErrors($form, errors = {}) {
    for (const [fieldName, messages] of Object.entries(errors)) {
        const message = Array.isArray(messages) ? messages[0] : messages;

        const $input = $form.find(`[name="${fieldName}"]`);
        if ($input.length === 0) continue;

        const $row = $input.closest('.form-row');

        let $error = $row.find(`.field-error.field-${fieldName}-error`);
        if ($error.length === 0) {
            $error = $(`<p class="field-error field-${fieldName}-error" style="display:none;"></p>`);
            $row.append($error);
        }

        $error.text(message).show();
    }
}

/**
 * Binds live phone number validation to phone input.
 *
 * @param {jQuery} $input - Input element for the phone number.
 * @param {Object} options - Validation options.
 * @param {boolean} [options.isInternational=true] - Whether to validate as international.
 * @param {function(valid: boolean): void} [options.onValidChange] - Callback with validity state.
 */
export function bindPhoneValidation($input, {
    isInternational = true,
    onValidChange = null
} = {}) {
    $input.on('input', function () {
        const raw = $input.val().trim();
        const phoneNumber = raw.replace(/[^\d+]/g, '');
        const $row = $input.closest('.form-row');
        let isValid = true;

        // Hide all error messages first
        $row.find('.field-error').hide();

        if (!isInternational) {
            const startsWith07 = phoneNumber.startsWith('07');
            if (!startsWith07) {
                $row.find('.field-phone-ro-error').show();
                isValid = false;
            }
            if (phoneNumber.length !== 10) {
                $row.find('.field-phone-length-error').show();
                isValid = false;
            }
        } else {
            const startsWithZero = phoneNumber.startsWith('0');
            const startsWithPlus = phoneNumber.startsWith('+');
            if (!(startsWithZero || startsWithPlus)) {
                $row.find('.field-phone-ro-error').show();
                isValid = false;
            }
            if (phoneNumber.length <= 6) {
                $row.find('.field-phone-length-error').show();
                isValid = false;
            }
        }

        if (typeof onValidChange === 'function') {
            onValidChange(isValid);
        }
    });
}
